<div class="chat-panel-container">
  <div class="chat-panel-note" role="note" aria-label="Large PDF processing note">
    Large PDFs up to 300 MB can take around 30 minutes to process.
  </div>

  <!-- Message Area -->
  <div class="chat-body" #chatBody>
    <div class="messages-container">
      <div *ngFor="let msg of messages" class="message-row" [ngClass]="{'message-row-user': msg.sender === 'user', 'message-row-agent': msg.sender === 'agent', 'message-row-with-options': msg.type === 'option', 'message-row-json': msg.type === 'json'}" [hidden]="!hasVisibleContent(msg)">
        <!-- Agent Avatar -->
        <div *ngIf="msg.sender === 'agent'" class="agent-avatar">A</div>
        
        <div *ngIf="hasVisibleContent(msg)" class="message-bubble" [ngClass]="msg.sender === 'user' ? 'user-message' : 'agent-message'">
          <div class="message-content" *ngIf="!msg.type || msg.type === 'option'">
            <app-streaming-text *ngIf="msg.sender === 'agent'" [content]="msg.formattedText || msg.text"></app-streaming-text>
            <div *ngIf="msg.sender === 'user'" [innerHTML]="msg.formattedText || msg.text"></div>
          </div>
          <app-dynamic-edit-table *ngIf="msg.type === 'table'" [data]="msg.data" [isChat]="true"></app-dynamic-edit-table>
          <div *ngIf="msg.type === 'json'" class="json-container">
            <textarea class="json-editor" [(ngModel)]="msg.rawJson" readonly></textarea>
            <button class="copy-json-button" (click)="copyJson(msg)" matTooltip="Copy JSON">
              <mat-icon>content_copy</mat-icon>
            </button>
            <span *ngIf="msg.copied" class="copy-success-message">Copied to clipboard!</span>
          </div>

          <div *ngIf="msg.figures?.length" class="figure-gallery">
            <figure *ngFor="let figure of msg.figures; trackBy: trackFigure" class="figure-card">
              <img class="figure-image" [src]="figure.url" [alt]="figure.caption || 'Chat figure'" loading="lazy" />
              <figcaption *ngIf="figure.caption" class="figure-caption">{{ figure.caption }}</figcaption>
            </figure>
          </div>

          <!-- Attached files shown in sent messages -->
          <div *ngIf="msg.files?.length" class="attached-files">
            <div *ngFor="let file of msg.files" class="attached-file">
              <ng-container *ngIf="isImageFile(file); else nonImageAttachment">
                <div class="attached-file attached-file-image">
                  <div class="attached-image-wrap">
                    <img class="attached-image" [src]="getFilePreviewUrl(file)" [alt]="file.name" />
                  </div>
                  <span class="attached-file-name">{{ file.name }}</span>
                </div>
              </ng-container>
              <ng-template #nonImageAttachment>
                <div class="attached-file attached-file-inline">
                  <mat-icon>attach_file</mat-icon>
                  <span class="attached-file-name">{{ file.name }}</span>
                </div>
              </ng-template>
            </div>
          </div>

        </div>
        <div *ngIf="msg.type === 'option'" class="options-container">
          <button *ngFor="let option of msg.data" class="chat-option-button" (click)="onOptionSelected(option.key)">
            {{ option.label }}
          </button>
        </div>
      </div>

      <div *ngIf="shouldShowTypingIndicator" class="message-row message-row-agent">
        <div class="agent-avatar">A</div>
        <div class="message-bubble agent-message typing-indicator" aria-live="polite" aria-label="Agent is typing">
          <span class="dot"></span>
          <span class="dot"></span>
          <span class="dot"></span>
        </div>
      </div>

    </div>
  </div>

  <!-- Input Area -->
  <div class="chat-footer">
    <div class="input-container">
      <button class="new-session-button" type="button" (click)="startNewSession()" matTooltip="Start new chat">
        <mat-icon>add_comment</mat-icon>
        <span>New</span>
      </button>

      <div class="input-wrapper">
        <!-- Upload Icon inside the input box -->
        <label class="upload-icon" matTooltip="Upload file">
          <input type="file" multiple (change)="onFileSelected($event)" hidden />
          <mat-icon>attach_file</mat-icon>
        </label>

        <!-- File Previews + Message Input -->
        <div class="input-content">
          <!-- Uploaded files shown above the text -->
          <div *ngIf="selectedFiles.length > 0" class="file-chips">
            <div *ngFor="let file of selectedFiles" class="file-chip">
              <img *ngIf="isImageFile(file)" class="file-chip-thumb" [src]="getFilePreviewUrl(file)" [alt]="file.name" />
              <mat-icon *ngIf="!isImageFile(file)">insert_drive_file</mat-icon>
              <span>{{ file.name }}</span>
              <button mat-icon-button (click)="removeFile(file)" matTooltip="Remove">
                <mat-icon>close</mat-icon>
              </button>
            </div>
          </div>

          <!-- Multi-line message input -->
          <textarea class="chat-input" placeholder="Type a message..." [(ngModel)]="currentMessage"
            (keyup.enter)="sendMessageOnEnter($event)" [disabled]="isLoading" rows="1"></textarea>
        </div>

      </div>

      <!-- Send Button -->
      <button class="send-btn" (click)="sendMessage()" mat-icon-button [disabled]="isLoading">
        <mat-icon>send</mat-icon>
      </button>
    </div>
  </div>
</div>
